import { z } from "zod"
import { geoJsonFeatureSchema } from "../geojson"

export const faaNmsInternalErrorSchema = z.object({
    code: z.string(),
    message: z.string(),
})

export const faaNmsTokenResponseSchema = z.object({
    access_token: z.string(),
    expires_in: z.string(),
    token_type: z.string(),
})

export const faaNmsNotamResponseSchema = z.object({
    status: z.string(),
    errors: z.array(faaNmsInternalErrorSchema).optional(),
    data: z
        .object({
            geojson: z.array(geoJsonFeatureSchema).optional(),
        })
        .loose(),
})

export const faaNmsNotamSchema = z
    .object({
        id: z.string(),
        number: z.string().optional(),
        type: z.string().optional(),
        classification: z.string().optional(),
        location: z.string().optional(),
        icaoLocation: z.string().optional(),
        effectiveStart: z.string().optional(),
        effectiveEnd: z.string().optional(),
        cancelationDate: z.string().optional(),
        text: z.string().optional(),
    })
    .loose()

export const faaNmsNotamTranslationSchema = z
    .object({
        type: z.string(),
        simpleText: z.string().optional(),
        formattedText: z.string().optional(),
    })
    .loose()

export const faaNmsNotamFeatureSchema = z
    .object({
        type: z.literal("Feature"),
        geometry: z.object({ type: z.string() }).loose().nullable(),
        properties: z
            .object({
                coreNOTAMData: z
                    .object({
                        notam: faaNmsNotamSchema,
                        notamTranslation: z.array(faaNmsNotamTranslationSchema).optional(),
                    })
                    .loose(),
            })
            .loose(),
    })
    .loose()

export const faaNmsBulkResponseSchema = z.object({
    status: z.string(),
    errors: z.array(faaNmsInternalErrorSchema).optional(),
    data: z.object({ url: z.string() }).loose(),
})

export type FaaNmsInternalError = z.infer<typeof faaNmsInternalErrorSchema>
export type FaaNmsNotamResponse = z.infer<typeof faaNmsNotamResponseSchema>
export type FaaNmsNotam = z.infer<typeof faaNmsNotamSchema>
export type FaaNmsNotamTranslation = z.infer<typeof faaNmsNotamTranslationSchema>
export type FaaNmsBulkResponse = z.infer<typeof faaNmsBulkResponseSchema>
